import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {
  CUSTOM_REMINDER_ID,
  FETCH_CUSTOM_REMINDERS_PAGINATION,
  GET_CUSTOM_REMINDERS,
} from '../graphql/query/custom-reminder.query';
import { map, Observable } from 'rxjs';
import {
  CREATE_CUSTOM_REMINDER,
  REMOVE_CUSTOM_REMINDER,
  UPDATE_CUSTOM_REMINDER,
} from '../graphql/mutation/custom-reminder.mutation';

@Injectable({
  providedIn: 'root',
})
export class CustomReminderService {
  constructor(private apollo: Apollo) {}

  customReminders(filter: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: GET_CUSTOM_REMINDERS,
        variables: { filter },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.customReminders || []));
  }
  
  customReminder(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: CUSTOM_REMINDER_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.customReminder || []));
  }

  findAllCustomRemindersWithPagination(filter: any): Observable<any> {
    return this.apollo
      .use('project')
      .watchQuery<any>({
        query: FETCH_CUSTOM_REMINDERS_PAGINATION,
        variables: { filter },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((result) => result.data?.findAllCustomRemindersWithPagination || [])
      );
  }

  createCustomReminder(input: any): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: CREATE_CUSTOM_REMINDER,
        variables: {
          input,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.createCustomReminder || []));
  }
  updateCustomReminder(id: any, input: any): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: UPDATE_CUSTOM_REMINDER,
        variables: {
          input,
          id,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.updateCustomReminder || []));
  }
  removeCustomReminder(id: any): Observable<any> {
    return this.apollo
      .use('project')
      .mutate({
        mutation: REMOVE_CUSTOM_REMINDER,
        variables: {
          id,
        },
        fetchPolicy: 'network-only',
      })
      .pipe(map((result: any) => result.data.removeCustomReminder || []));
  }
}
